module.exports = __webpack_public_path__ + "img/head.4a419512.svg";